import Vue from 'vue'
import App from '@/containers/App/App'
import router from '@/router'
import VModal from 'vue-js-modal'
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)
Vue.use(VModal)

/*
	- global event bus
	this way, you do not have to export the event bus in each components
*/
Vue.prototype.$eventHub = new Vue();

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	template: '<App/>',
	components: {
		App,
	}
})


// WEBPACK FOOTER //
// ./src/main.js